"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@rradar/core");
var React = require("react");
var CancelButton = function (props) {
    return (React.createElement(core_1.Button, { buttonType: "secondary", onClick: function () { return props.cancelFunction(); } }, props.cancelText ? props.cancelText : 'Cancel'));
};
exports.default = CancelButton;
